import { PaymentMethod } from '@stripe/stripe-js';
import { CouponItem, OfferType, PackageId, Packages } from '../../types/billing';

export interface SubscriptionCodeDetail extends CouponItem {
  isValid?: boolean;
  isClaimed?: boolean;
  success?: boolean;
  activationCode?: string;

  partner?: any;
  terms?: string;
  bearer?: boolean;
  redirectURL?: string | null;
}

export type SelectedAddOnIds = Record<PackageId, boolean>;

export interface SharedBillingState {
  isCheckingSubscriptionCode: boolean;
  subscriptionCode: string;
  subscriptionCodeType: OfferType | '';
  subscriptionCodeDetails: SubscriptionCodeDetail[];
  subscriptionCodeValidationError: string;
  subscriptionCodeValid: boolean;
  subscriptionCodeTermsUrl: string;

  setupIntentId: string;
  shouldSetupIntent: boolean;
  stripePaymentErrorMessage: string;
  stripePaymentLoading: boolean;
  stripePaymentReady: boolean;
  stripePaymentMethodId: PaymentMethod | string;
  zipCode: string;

  selectedPackageId: PackageId;
  selectedAddOnIds: SelectedAddOnIds;
  skipCustomZipCollection: boolean;

  priceChangeAnnouncementDate?: string;
  priceChangePackageId?: Packages;
  priceChangeIncreasedPriceCents?: number;
  priceChangeEffectiveDate?: string;
}

export const initialState: SharedBillingState = {
  isCheckingSubscriptionCode: false,
  subscriptionCode: '',
  subscriptionCodeType: '',
  subscriptionCodeDetails: [],
  subscriptionCodeValidationError: '',
  subscriptionCodeValid: false,
  subscriptionCodeTermsUrl: '',

  setupIntentId: '',
  shouldSetupIntent: true,
  stripePaymentErrorMessage: '',
  stripePaymentLoading: false,
  stripePaymentReady: false,
  stripePaymentMethodId: '',
  zipCode: '',

  selectedPackageId: Packages.PHILO_ARGON,
  selectedAddOnIds: {} as SelectedAddOnIds,
  skipCustomZipCollection: false,
};
